<h2 mat-dialog-title>Delete SKU</h2>
<mat-dialog-content>
  <p>
    Are you sure you want to delete
    <strong>{{ data.sku_name }}</strong>?
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="modal-btn-group">
    <button mat-button mat-dialog-close color="primary" class="secondary-btn mr-15 mb-15">Cancel</button>
    <button
      mat-flat-button
      mat-dialog-close
      cdkFocusInitial
      color="primary"
      class="primary-btn mr-15 mb-15"
      (click)="confirmDelete()"
    >
      Delete SKU
    </button>
  </div>
</mat-dialog-actions>
